module.exports = () => {
	return new Promise((resolve) => {
		return resolve(navigator.userAgent || '');
	});
};
